import { PIECE_TYPES } from "@/game/pieces";
import type { Club } from "@/lib/api";
import { Tetromino } from "./Tetromino";

interface FooterProps {
  readonly club: Club | null;
}

export function Footer({ club }: FooterProps) {
  return (
    <footer className="border-t-2 border-ink bg-field pb-[76px] xl:pb-0">
      {/* One last cleared line. */}
      <div className="flex h-7 w-full">
        {PIECE_TYPES.map((piece) => (
          <span
            key={piece}
            className="flex-1 border-r-2 border-ink last:border-r-0"
            style={{ background: `var(--color-piece-${piece.toLowerCase()})` }}
          />
        ))}
      </div>

      <div className="shell grid gap-8 py-10 md:grid-cols-[1fr_auto] md:items-start md:gap-12">
        <div className="flex items-center gap-3">
          <img
            src="/logo.webp"
            alt=""
            width={44}
            height={44}
            className="h-11 w-11 shrink-0 border-2 border-ink"
          />
          <div>
            <p className="display text-lg leading-none">Tetris At UCI</p>
            <p className="meta mt-1.5 opacity-60">
              {club?.campus ?? "University of California, Irvine"}
            </p>
          </div>
        </div>

        <nav
          aria-label="Footer"
          className="flex flex-wrap items-center gap-x-5 gap-y-2 md:justify-end"
        >
          {(club?.links ?? []).map((link) => (
            <a
              key={link.label}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="meta underline-offset-4 hover:underline"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-end gap-6 border-t-2 border-ink pt-6 md:col-span-2">
          <p className="max-w-[62ch] text-[0.8125rem] leading-relaxed opacity-65">
            Standings come from the TETR.IO community API and may lag behind the game by a few
            minutes. Tetris is a trademark of the Tetris Company; this is an unaffiliated student
            club site.
          </p>
          <span className="ml-auto hidden shrink-0 sm:block">
            <Tetromino type="I" cell={9} />
          </span>
        </div>
      </div>
    </footer>
  );
}
